import React, { memo } from "react";
import { View, Image } from "react-native";
import { styles } from "./styles";

export const Images = memo(
  ({ images }) => (
    <View style={styles.container}>
      {images.map(image => (
        <>
          <Image
            key={image.id}
            style={[
              styles.image,
              {
                height: image.height,
                width: image.width,
              },
            ]}
            source={{ uri: image.image || null }}
            resizeMode="cover"
          />
        </>
      ))}
    </View>
  ),
  () => true,
);
